import { type ReactNode } from 'react';
import { cn } from '~/shared/components/utils';

export interface ButtonLinkProps {
	label: string;
	selected?: boolean;
	onClick?: () => void;
	className?: string;
	children?: (selected: boolean) => ReactNode;
}

export function ButtonLink({ label, selected = false, onClick, className, children }: ButtonLinkProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={cn(
				'flex w-full items-center justify-between border-b border-gray-100 px-3.5 py-3 text-xs transition-colors last:border-b-0',
				selected ? 'bg-primary-50 font-semibold text-primary-700' : 'font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-800',
				className
			)}
		>
			<span className="hidden lg:block">{label}</span>
			<span className="lg:hidden">{label.substring(0, 2)}</span>
			{children?.(selected)}
		</button>
	);
}
